export class AbstractText {

  constructor(descPart?: string, publicHealthPart?: string) {
      this.descPart = descPart;
      this.publicHealthPart = publicHealthPart;
    }

  public descPart: string;
  public publicHealthPart: string;
}